import { render } from "./simpleTable.vue?vue&type=template&id=67d68dbc&scoped=true"
import script from "./simpleTable.vue?vue&type=script&lang=js"
export * from "./simpleTable.vue?vue&type=script&lang=js"

import "./simpleTable.vue?vue&type=style&index=0&id=67d68dbc&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d68dbc"]])

export default __exports__